import { render, staticRenderFns } from "./DefaultWsImageButtons.vue?vue&type=template&id=8576c332&scoped=true"
import script from "./DefaultWsImageButtons.vue?vue&type=script&lang=ts"
export * from "./DefaultWsImageButtons.vue?vue&type=script&lang=ts"
import style0 from "./DefaultWsImageButtons.vue?vue&type=style&index=0&id=8576c332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8576c332",
  null
  
)

/* custom blocks */
import block0 from "./DefaultWsImageButtons.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports